import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { debounce } from 'utils/common';
import {  useSelector } from 'react-redux';
import {toTitleCase} from "utils/common"

export default function useEmployeeFilter(pageSettings , setPageSettings) {
    const [searchParams, setSearchParams] = useSearchParams();
    const {
        department, departmentLoading,
        reportTo, reportToLoading,
        nationality, nationalityLoading,
        position, positionLoading,
        division, divisionLoading,
        
    } = useSelector((state) => state.common);

    const [filterLoading, setFilterLoading] = useState(false)
  const [filters, setFilters] = useState([
    {
        key: "search",
        label: "Search term",
        value: searchParams.get("search") || ""
    },
   
   
    {
        key: "department",
        label: "",
        value: searchParams.get("department") || ""
    },
   
    {
        key: "position",
        label: "",
        value: searchParams.get("position") || ""
    },
    {
        key: "division",
        label: "",
        value: searchParams.get("division") || ""
    },
   
  ]);

  useEffect(()=>{

    if(!departmentLoading && !reportToLoading && !nationalityLoading && !positionLoading && !divisionLoading ){
        let gender = searchParams.get("gender") || ""

        let selectedReportTo = [...reportTo].find(item=>item.user_id == searchParams.get("report_to") || "")
        let selectedDepartment = [...department].find(item=>item.id == searchParams.get("department") || "")
        let selectedNationality = [...nationality].find(item=>item.id == searchParams.get("nationality") || "")
        let selectedPosition = [...position].find(item=>item.id == searchParams.get("position") || "")
        let selectedDivision = [...division].find(item=>item.id == searchParams.get("division") || "")
        let selectedMarital = searchParams.get("marital_status") || ""
    
        let _filters = [
            {
                key: "search",
                label: "Search term",
                value: searchParams.get("search") || ""
            },
            
            {
                key: "department",
                label: selectedDepartment?.name,
                value: searchParams.get("department") || ""
            },
          
            {
                key: "position",
                label: selectedPosition?.name,
                value: searchParams.get("position") || ""
            },
            {
                key: "division",
                label: selectedDivision?.name,
                value: searchParams.get("division") || ""
            },
           
          ]
          setFilters(_filters)
    }

 
  },[
    department,
    reportTo,
    nationality,
    position,
    division
  ])

  const handleFilterChange =  (data, key, make_call=false) => {
    console.log( "AAAA")

    let _filters = [...filters]
    let selectedFilter = _filters.find(item=> item.key === key)
    selectedFilter['label'] = data?.label || ""
    selectedFilter['value'] = data?.value || ""
    setFilters(_filters)
    console.log( _filters, "AAAA")
    if(make_call){
        setPageSettings({
            ...pageSettings,
            page:1,
            filters: _filters
    
        })
    }


    
  };
  const handleInputChange = debounce((data, key, make_call=false) => {
    console.log( "FFFF")

    let _filters = [...filters]
    let selectedFilter = _filters.find(item=> item.key === key)
    selectedFilter['label'] = key
    selectedFilter['value'] = data
    setFilters(_filters)

    if(make_call){

        
        setPageSettings({
            ...pageSettings,
            page:1,
            filters: _filters
    
        })
    }

  }, 1000)

  const handleDateChange = (data, key, make_call=false) => {

    
    let _filters = [...filters]
    let selectedFilter = _filters.find(item=> item.key === key)
    selectedFilter['label'] = key
    selectedFilter['value'] = data
    setFilters(_filters)

    if(make_call){

        
        setPageSettings({
            ...pageSettings,
            page:1,
            filters: _filters
    
        })
    }

  }

  return {
    handleFilterChange,
    filters,
    handleInputChange,
    filterLoading, setFilterLoading,
    handleDateChange
  };
}
